import getTourOptions, { getTourRateOption } from './getTourOptions';
import { TourPricingModelKinds } from '../constants';

const getTourRateChoice = ({
  productRates,
  offeredRates,
  pricingModelKind,
  pickedOption,
  pricedRateQuantities,
}) => {
  const published = productRates || [];
  const offered = offeredRates || [];
  const options = getTourOptions(published);
  const askedRate = published.find(
    (rate) => (pricedRateQuantities || {})[rate.parameterName || rate.name],
  );
  const option = pickedOption || getTourRateOption(askedRate) || options[0];

  const choice = {
    options,
    option,
    rates: options.length ? offered.filter((rate) => getTourRateOption(rate) === option) : offered,
    isSingleChoice: pricingModelKind === TourPricingModelKinds.TIME_BASED,
  };
  return choice;
};

export default getTourRateChoice;
